import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { useMutation } from "@apollo/react-hooks";
import { UPDATE_EMAIL } from "utils";
import { ERROR_STATUS } from "utils/constants";
import UpdateUserDetailsModal from "./UpdateUserDetailsModal";

const UpdateEmailModal = ({
  user,
  setNewEmail,
  setEmailUpdated,
  agent_email
}) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [updateEmail] = useMutation(UPDATE_EMAIL);
  const history = useHistory();

  const handleSubmit = async email => {
    if (!email || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i.test(email)) {
      setErrorMessage("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    const emailToPass = email.toLowerCase();
    const res = await updateEmail({
      variables: {
        oldEmail: user.email,
        newEmail: emailToPass,
        agent_email
      }
    });

    const {
      data: {
        updateEmail: { status, message }
      }
    } = res;

    if (status === ERROR_STATUS) {
      if (message === "[updateEmail]: User with desired email exists.") {
        setErrorMessage("The desired email is already in use by another user.");
        setLoading(false);
        return;
      }
      setErrorMessage(
        "There was an error updating the email. Please try again in 5 minutes.  If this persists, please reach out to dev-support."
      );
      setLoading(false);
      return;
    }
    setLoading(false);
    setSuccess(true);
    setEmailUpdated(true);
    setNewEmail(emailToPass);
    history.push(`/supportal/user?email=${encodeURIComponent(emailToPass)}`);
  };

  return (
    <UpdateUserDetailsModal
      label="Email"
      currentValue={user.email}
      onSubmit={() => handleSubmit(email)}
      updateNewValue={setEmail}
      errorMessage={errorMessage}
      loading={loading}
      successMainMessage="Email has been updated to:"
      successSubMessage={`${email.toLowerCase()}`}
      showSuccessState={success}
    />
  );
};

const mapStateToProps = state => ({
  agent_email: state.user.id
});

export default connect(mapStateToProps, null)(UpdateEmailModal);
